import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Suppress third-party script errors (PostHog, analytics, etc.) from error overlay
const originalError = console.error;
console.error = (...args) => {
  // Filter out PostHog/analytics errors
  if (args[0]?.toString?.().includes('posthog') || 
      args[0]?.toString?.().includes('PerformanceServerTiming') ||
      args[0]?.toString?.().includes('postMessage')) {
    return;
  }
  originalError.apply(console, args);
};

// Suppress uncaught errors from third-party scripts
window.addEventListener('error', (event) => {
  if (event.filename?.includes('posthog') || 
      event.message?.includes('PerformanceServerTiming') ||
      event.message?.includes('postMessage')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
